import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlassPlus } from "@fortawesome/free-solid-svg-icons";

interface IIcon {
  color: string;
}

const ZoomInIcon: React.FC<IIcon> = ({ color }) => {
  return <FontAwesomeIcon icon={faMagnifyingGlassPlus} style={{ color }} width={20} height={20} />;
};

export default ZoomInIcon;
